import { Button, Form, Input } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import React from 'react'
import Text from 'components/Text'
import { useTranslation } from 'react-i18next'

const CognitoConfirmPasswordForm = ({
  cognitoForgotPasswordError,
  confirmPasswordForm,
  handleCancelForgotPasswordClick,
  handleConfirmResetPasswordSubmit,
  isResettingPassword,
}) => {
  const { t } = useTranslation()

  return (
    <div className="login__forgot-password-container">
      <Text className="login__sign-in-label">
        {t('login.resetPassword.enterCodeTitle')}
      </Text>

      <Form
        className="login__sign-in-form"
        form={confirmPasswordForm}
        onFinish={handleConfirmResetPasswordSubmit}
      >
        <Form.Item
          name="code"
          rules={[
            { message: t('login.resetPassword.codeMissing'), required: true },
          ]}
        >
          <Input
            placeholder={t('login.resetPassword.codePlaceholder')}
            prefix={<LockOutlined className="login__form-field-icon" />}
          />
        </Form.Item>

        <Form.Item
          name="newPassword"
          rules={[
            {
              message: t('login.resetPassword.newPasswordMissing'),
              required: true,
            },
          ]}
        >
          <Input
            placeholder={t('login.resetPassword.newPasswordPlaceholder')}
            prefix={<LockOutlined className="login__form-field-icon" />}
            type="password"
          />
        </Form.Item>

        <Form.Item
          dependencies={['newPassword']}
          name="confirmPassword"
          rules={[
            {
              message: t('login.resetPassword.confirmPasswordMissing'),
              required: true,
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve()
                }

                return Promise.reject(
                  new Error(t('login.resetPassword.passwordsDoNotMatch'))
                )
              },
            }),
          ]}
        >
          <Input
            placeholder={t('login.resetPassword.confirmPasswordPlaceholder')}
            prefix={<LockOutlined className="login__form-field-icon" />}
            type="password"
          />
        </Form.Item>

        {cognitoForgotPasswordError && (
          <Form.Item>
            <Text className="login__sign-in-error">
              {cognitoForgotPasswordError}
            </Text>
          </Form.Item>
        )}

        <Form.Item>
          <Button
            className="login__submit-button"
            htmlType="submit"
            loading={isResettingPassword}
            type="primary"
          >
            {t('login.resetPassword.resetPassword')}
          </Button>

          <Button
            className="login__submit-button"
            onClick={handleCancelForgotPasswordClick}
            type="secondary"
          >
            {t('login.cancel')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

CognitoConfirmPasswordForm.propTypes = {
  cognitoForgotPasswordError: PropTypes.string,
  confirmPasswordForm: PropTypes.object.isRequired,
  handleCancelForgotPasswordClick: PropTypes.func.isRequired,
  handleConfirmResetPasswordSubmit: PropTypes.func.isRequired,
  isResettingPassword: PropTypes.bool.isRequired,
}

export default CognitoConfirmPasswordForm
